import React, { useEffect, useState } from "react";
import "./View_User_Modal.css";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import {
  Update,
  findOne,
} from "../../../utils/apis/booking/flight_booking/flight_booking";
import { formatDate } from "../../../utils/common";
function View_User_Modal(props) {
  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder View_User_Modal"
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal_Heading modalHeading={"View Booking"} />
          <div className="modal-body-holder">
            <Modal.Body>
              <div className="main-form-holder">
                <div>
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12">
                      <div className="user-list-table">
                        {/* <Banner_List_Table /> */}

                        <div className="data-table-holder">
                          <Table responsive bordered striped>
                            <thead>
                              <tr>
                                <th>Sr. No</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>Phone No</th>
                                <th>DOB</th>
                                <th>Gender</th>
                                <th>Address</th>
                                <th>Base Fare</th>
                                <th>Currency code</th>
                                <th>Passport No</th>
                                <th>Passport Expiry</th>
                                <th>Offered Price</th>
                                <th>Tax</th>
                              </tr>
                            </thead>

                            <tbody>
                              {props?.show?.passenger_data &&
                                props?.show?.passenger_data?.map(
                                  (val, index) => (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{val?.FirstName}</td>
                                      <td>{val?.LastName}</td>
                                      <td>{val?.Email}</td>
                                      <td>{val?.ContactNo}</td>
                                      <td>{formatDate(val?.DateOfBirth)}</td>
                                      <td>
                                        {val?.Gender === 1
                                          ? "Male"
                                          : val?.Gender === 2
                                          ? "Female"
                                          : "Others"}
                                      </td>
                                      <td>{val?.AddressLine1}</td>
                                      <td>{val?.Fare?.BaseFare}</td>
                                      <td>{val?.Fare?.Currency}</td>
                                      <td>{val?.PassportNo}</td>
                                      <td>
                                        {val?.PassportExpiry &&
                                          formatDate(val?.PassportExpiry)}
                                      </td>
                                      <td>{val?.Fare?.PublishedFare}</td>
                                      <td>{val?.Fare?.Tax}</td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </Table>

                          <CustomPaginate
                          // currentPage={data?.data?.current_page}
                          // totalPages={data?.data?.total_pages}
                          // handlePageChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer-holder">
                  <div className="row justify-content-center">
                    <Button className="search-btn" onClick={props.onHide}>
                      Cancel
                    </Button>

                    {/* <div className="col-md-6 col-sm-6 col-6">
                      <Button className="reset-btn " type="button">
                        Submit
                      </Button>
                    </div> */}
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
      </section>
    </>
  );
}

export default View_User_Modal;
